import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Handles download requests by obtaining a fresh presigned URL for every click.
 */
export const onDownloadRequest = store.effects.create(
  // NOTE: Types will be inferred from feature when registered
  (feature: Feature) =>
    feature.actions.download.request.observe().pipe(
      rxjs.mergeMap(action => {
        const { id, extension, purpose, context, qualifier } = action.data

        return feature.api
          .getDownloadRequest({
            context,
            extension,
            id,
            purpose,
            qualifier,
          })
          .pipe(
            rxjs.map(url =>
              feature.actions.download.success.from(action).create({
                request: action.data,
                response: url,
              }),
            ),
            rxjs.catchError((error: unknown) =>
              rxjs.of(
                feature.actions.download.error.from(action).create({
                  error:
                    error instanceof Error ? error : new Error(String(error)),
                  request: action.data,
                }),
              ),
            ),
          )
      }),
    ),
)
